// extracted by mini-css-extract-plugin
module.exports = {"title":"QuantityPurchased_title__HbJMj"};